import React from 'react';
import { useIntl } from 'react-intl';
import { WELCOME_MESSAGE_ID } from '~/features/chatbot/constants/messages';
import { PREDEFINED_QUESTION_IDS } from '~/features/chatbot/constants/predefinedQuestions';

interface WelcomeMessageProps {
    onQuestionClick: (question: string) => void;
}

const WelcomeMessage: React.FC<WelcomeMessageProps> = ({ onQuestionClick }) => {
    const intl = useIntl();

    return (
        <div className="padding-20">
            <div className="bg-lightest padding-15 rounded margin-bottom-15 max-width-75pct">
                <span className="rioglyph rioglyph-chat margin-right-5" aria-hidden="true" />
                <span>{intl.formatMessage({ id: WELCOME_MESSAGE_ID })}</span>
            </div>
            <div className="display-flex flex-wrap gap-10">
                {PREDEFINED_QUESTION_IDS.map((questionId) => {
                    const label = intl.formatMessage({ id: questionId });
                    return (
                        <button
                            key={questionId}
                            type="button"
                            className="btn btn-default btn-sm"
                            onClick={() => onQuestionClick(label)}
                        >
                            {label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default WelcomeMessage;
